export default {
  namespaced: true,
  state: () => ({
    alerts: []
  }),
  mutations: {
    ADD_ALERT(state, alert) {
      state.alerts.push(alert);
    },
    REMOVE_ALERT(state, id) {
     state.alerts = state.alerts.filter(a => a.id !== id);
    }
  },
  actions: {
    showAlert({ commit }, alert) {
      const id = Date.now() + Math.random();
      const alertWithId = { ...alert, id };

      commit("ADD_ALERT", alertWithId);

      // Авто-закрытие
      if (alert.autoClose?.enabled) {
        setTimeout(() => {
          commit("REMOVE_ALERT", id);
        }, alert.autoClose.delay || 3000);
      }
    },
    removeAlert({ commit }, id) {
      commit("REMOVE_ALERT", id);
    }
  },
  getters: {
    allAlerts: (state) => state.alerts
  }
};

//Успех
/*
this.$store.dispatch("alert/showAlert", {
  title: "Успех",
  message: "Данные сохранены!",
  type: "success", 
  typeClass: "alert-success",
  background: "#d4edda",
  color: "#155724",
  autoClose: { enabled: true, delay: 3000 },
  position: { top: "50px", right: "50px", zIndex: 1100 }
});
*/
//Предупреждение
/*
this.$store.dispatch("alert/showAlert", {
  title: "Внимание",
  message: "Проверьте введённые данные!",
  type: "warning",          // тип для SVG иконки
  typeClass: "alert-warning",
  background: "#fff3cd",
  color: "#856404",
  autoClose: { enabled: true, delay: 4000 }
});
*/
//Ошибка
/*
this.$store.dispatch("alert/showAlert", {
  title: "Ошибка",
  message: "Не удалось сохранить данные!",
  type: "error",            // тип для SVG иконки
  typeClass: "alert-error",
  background: "#f8d7da",
  color: "#721c24",
  autoClose: { enabled: true, delay: 5000 }
});
*/